import styled from "styled-components";

interface TextColorCardProps {
	text: string;
	textColor: string;
	backgroundColor: string;
}

export const TextColorCard = ({ text, textColor = "#c4c4c4", backgroundColor }: TextColorCardProps): JSX.Element => {
	return (
		<CardContainer background={backgroundColor}>
			<Text color={textColor}>{text}</Text>
		</CardContainer>
	);
};

interface CardContainerProps extends React.HTMLAttributes<HTMLDivElement> {
	background?: string;
}

const CardContainer = styled.div<CardContainerProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	background: ${({ background }) => background};
    padding: 8px;
    max-width: 240px;
`;

interface TextProps extends React.HTMLAttributes<HTMLDivElement> {
	color?: string;
}

const Text = styled.div<TextProps>`
	color: #333;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	line-height: 150%;
	display: -webkit-box;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 1;
`;
